import { PoolFragmentFragment } from "../../gql/generated/stats2.sdk";
import { useOrderContext } from "../../stores/OrderContext";

export const usePoolFromOrderRoute = () => {
  const {
    state: { orderRoute },
  } = useOrderContext();

  return orderRoute?.[0] || ({} as PoolFragmentFragment);
};
